import { apiDomain } from "./constraint";

export const loginToDelete = async (email, password, lang) => {
  try {
    const response = await fetch(
      `${apiDomain}/deleteAccountWithEmailAndPassword`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, password: password, lang: lang }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const deleteAccountWithApple = async (idToken, email, lang) => {
  try {
    console.log(
      "deleteAccountWithApple" +
        JSON.stringify({ idToken: idToken, email: email, lang: lang })
    );

    const response = await fetch(`${apiDomain}/sendDeletionEmailWithToken`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idToken: idToken, email: email, lang: lang }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
